module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "safezone-coverUp",
    style: ({
      top: 0,
      width: '100%',
      height: _vm.SafeTop + 'px'
    })
  }), _vm._v(" "), _c('main', {
    class: {
      flex: true,
      col: true,
      h100: true
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "safezone-coverDown",
    style: ({
      bottom: 0,
      width: '100%',
      height: _vm.SafeBottom + 'px'
    })
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading) ? _c('Loading', {
    attrs: {
      "loadingValue": _vm.loadingValue
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.loading) ? _c('Popup') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417cff44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 594
// module chunks = 9